// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./LogOutIcon.data";

export const LogOutIcon = createIcon("LogOutIcon", iconNode);
